// import React , { useState, useEffect }from "react"
import { useTranslation } from 'react-i18next';

const Section4 = () => {
	const {t} = useTranslation();
	
	return (
		<section className="service-section funfact-section-isu">
			<div className="container">
				<div className="row justify-content-between">
					<div className="col-lg-6" data-aos="zoom-in-left">
						<div className="section-title-box">
							<div className="section-tagline-b-x" style={{color:'#F4EE5C'}}>{t('isuUtama')}</div>
							<h2 className="section-title text-white">{t('isuJudul')}
								<br /> {t('isuJudul2')}</h2>
							<div className="section-text-b">
								<p>{t('isuIsi')}</p>
							</div>
							<div className="service-arrow-image">
								<img src="/assets/image/shapes/arrow.png" alt="img-6" />
							</div>
						</div>
					</div>
					<div className="col-lg-5" data-aos="zoom-in-right">
						<div className="service-card">
							<ul className="list-unstyled">
								<li><a href="/industri-produk-halal/MQ==/mainpage">{t('isuPengembanganProdukIndustriHalal')} <i className="fa-solid fa-chevron-right"></i></a></li>
								<li><a href="/jasa-keuangan-syariah/Mg==/mainpage">{t('isuPengembanganJasaKeuanganSyariah')} <i className="fa-solid fa-chevron-right"></i></a></li>
								<li><a href="/keuangan-sosial-syariah/Mw==/mainpage">{t('isuPengembanganKeuanganSosialSyariah')} <i className="fa-solid fa-chevron-right"></i></a></li>
								<li><a href="/bisnis-dan-kewirausahaan-syariah/NA==/mainpage">{t('isuPengembanganBisnisDanKewirausahaanSyariah')} <i className="fa-solid fa-chevron-right"></i></a></li>
								<li><a href="/infrastruktur-ekosistem-syariah/NQ==/mainpage">{t('isuPengembanganInfrastrukturEkosistemSyariah')} <i className="fa-solid fa-chevron-right"></i></a></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>

	)
}
export default Section4
